import { Controller, type UseFormReturn } from "react-hook-form";
import {
  APAC_FORM_UI_NAME,
  ApacFormUiComponent,
  CountryCode,
  FormControlWrapper,
  PhoneNumber,
} from "@apac/form-ui";
import { useModuleBEM, useStyles } from "@b2bportal/core-themes";
import type { IContactInfo } from "@b2bportal/core-types";
import defaultStyles from "./styles.module.scss";

export interface PhoneNumberFieldProps {
  formContext: UseFormReturn<IContactInfo>;
  placeholder?: string;
  label?: string;
  required?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
}

export const PhoneNumberField = ({
  formContext,
  label,
  placeholder,
  helperText,
  disabled,
}: PhoneNumberFieldProps) => {
  const styles = useStyles(
    APAC_FORM_UI_NAME,
    ApacFormUiComponent.PhoneNumberField,
    defaultStyles
  );
  const { error: phoneNumberError, invalid } =
    formContext.getFieldState("phoneNumber");
  const [block, cn] = useModuleBEM(
    styles,
    ApacFormUiComponent.PhoneNumberField,
    {
      hasError: invalid,
    }
  );

  return (
    <FormControlWrapper
      className={block}
      label={label}
      required
      error={phoneNumberError?.message}
      helperText={helperText}
    >
      <div className={cn("container", { disabled })}>
        <Controller
          disabled={disabled}
          name="countryCode"
          control={formContext.control}
          render={({ field }) => (
            <CountryCode
              {...field}
              className={cn("country-code")}
              onValueChange={field.onChange}
            />
          )}
        />

        <Controller
          disabled={disabled}
          name="phoneNumber"
          control={formContext.control}
          render={({ field }) => (
            <div className={cn("phone-number-container")}>
              <PhoneNumber
                {...field}
                error={!!phoneNumberError}
                className={cn("phone-number")}
                placeholder={placeholder}
                onChange={(e) => {
                  field.onChange(e);
                  formContext.trigger("phoneNumber"); // trigger validation
                }}
              />
            </div>
          )}
        />
      </div>
    </FormControlWrapper>
  );
};
